import { HeaderCell } from "@/components/ui/table";
import DateCell from "@/components/ui/date-cell";
import { Badge } from "rizzui";
import { IIPTracking } from "@/utilities/types/IPTracking";

interface GetColumnsProps {
  data: IIPTracking[];
}

export function getColumns({ data }: GetColumnsProps) {
  return [
    {
      title: <HeaderCell title="IP Address" />,
      dataIndex: "ip",
      key: "ip",
      width: 150,
      render: (ip: string) => <span className="font-medium">{ip}</span>,
    },
    {
      title: <HeaderCell title="Project" />,
      dataIndex: "projectName",
      key: "projectName",
      width: 180,
      render: (projectName: string, record: IIPTracking) => (
        <div>
          <p className="font-medium">{projectName}</p>
          <a
            href={record.projectLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:underline"
          >
            {record.projectLink}
          </a>
        </div>
      ),
    },
    {
      title: <HeaderCell title="Domain" />,
      dataIndex: "domain",
      key: "domain",
      width: 150,
      render: (domain: string) => (
        <span className="text-gray-700">{domain}</span>
      ),
    },
    {
      title: <HeaderCell title="Country" />,
      dataIndex: "country",
      key: "country",
      width: 120,
      render: (country: string | null, record: IIPTracking) => (
        <span className="text-gray-700">
          {country
            ? `${record.countryCode ? getCountryFlag(record.countryCode) : ""} ${country}`
            : "—"}
        </span>
      ),
    },
    {
      title: <HeaderCell title="Region" />,
      dataIndex: "region",
      key: "region",
      width: 120,
      render: (region: string) => (
        <span className="text-gray-700">{region || "—"}</span>
      ),
    },
    {
      title: <HeaderCell title="Browser" />,
      dataIndex: "browser",
      key: "browser",
      width: 150,
      render: (browser: string) => (
        <span className="text-gray-500 text-sm">{browser || "—"}</span>
      ),
    },
    {
      title: <HeaderCell title="Status" />,
      dataIndex: "isSpam",
      key: "isSpam",
      width: 100,
      render: (isSpam: boolean) => (
        <Badge
          color={isSpam ? "red" : "green"}
          variant="flat"
          className="rounded-full px-2 py-1 text-xs"
        >
          {isSpam ? "🚫 Spam" : "✅ Valid"}
        </Badge>
      ),
    },
    {
      title: <HeaderCell title="Created At" />,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 180,
      render: (createdAt: string) => <DateCell date={new Date(createdAt)} />,
    },
  ];
}

// Helper function to get country flag emoji from country code
function getCountryFlag(countryCode: string): string {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
